/* ═══════════════════════════════════════════════════════════
   OTM CBD — Reveal au scroll
   Port fidèle de OTM Site - standalone source.html, méthode observe(),
   ligne 4499. Paramètres identiques : threshold 0.12, rootMargin -8%,
   état initial opacity 0 / translateY(22px), filet de sécurité 2200 ms.

   L'état initial est posé en JS et non en CSS : si le script ne
   s'exécute pas, le contenu reste visible.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var REVEAL_FALLBACK_MS = 2200;
  var io = null;

  function show(node) {
    node.style.opacity = '1';
    node.style.transform = 'none';
  }

  function observe() {
    var nodes = document.querySelectorAll('[data-reveal]');
    if (!nodes.length) return;

    // Respecte la préférence système : pas d'animation, pas de masquage.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              show(e.target);
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
    }

    nodes.forEach(function (n) {
      if (n.dataset.revealInit) return;
      n.dataset.revealInit = '1';
      n.style.opacity = '0';
      n.style.transform = 'translateY(22px)';
      io.observe(n);
      // Filet de sécurité : si l'observer ne déclenche jamais, on révèle.
      setTimeout(function () { show(n); }, REVEAL_FALLBACK_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Les sections rechargées par l'éditeur de thème doivent être ré-observées.
  document.addEventListener('shopify:section:load', observe);

  window.otmObserveReveal = observe;
})();
